// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FundTwoToneSvg from "@ant-design/icons-svg/es/asn/FundTwoTone";
import AntdIcon from '../components/AntdIcon';

var FundTwoTone = function FundTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: FundTwoToneSvg
  }));
};

FundTwoTone.displayName = 'FundTwoTone';
export default React.forwardRef(FundTwoTone);